import { Component, OnInit } from '@angular/core';
import { httpservice, Message } from 'src/app/commons/commons.module';
import { NgxEchartsModule } from 'ngx-echarts';
import { EChartsOption } from 'echarts';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chart-kvarovi',
  standalone: false,
  templateUrl: './chart-kvarovi.component.html',
  styleUrl: './chart-kvarovi.component.css'
})
export class ChartKvaroviComponent implements OnInit {
  getservice: httpservice;
  chartOption: any;
  dokumenti: any;
  ukupno: number;
  podaci: { value, name }[];

  constructor(dataservice: httpservice) {
    this.getservice = dataservice;
  }

  ngOnInit() {
    this.Ucitaj();
  }


  Inicijaliziraj() {
    this.chartOption = {
      title: {
        text: 'Broj naloga po vrsti kvara',
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          name: 'Vrsta kvara (rada)',
          type: 'pie',
          radius: '50%',
          data: [...this.podaci],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
    };
  }



  Ucitaj() {
    this.getservice.GetRequest<Message>("radninalozi/CountGroupByKvar").subscribe(result => {
      if (result.status === "success") {
        this.podaci = [,];
        this.dokumenti = result.data;
        this.ukupno = 0;
        result.data.forEach(e => {
          this.podaci.push({ value: e.broj, name: e.kvar });
          this.ukupno += e.broj;          
        });
        this.Inicijaliziraj();
      }
    }, error => console.error('Get naloge', error));
  }

}
